import React from "react";
import { Button, Table } from "antd";
import { useTranslation } from "react-i18next";
import { useDeleteUser, useGetUserOverview } from "../../queries/user";
import { UserRole } from "../../util/enums/UserRole.enum";
import { UserTag } from "../UserTag";

const UserTable = () => {
  const { t } = useTranslation();
  const { data: users } = useGetUserOverview();
  const { mutate: deleteUser } = useDeleteUser();

  const columns = [
    {
      title: t("pages.users.user-table.user-name"),
      dataIndex: "fullName",
      key: "fullName",
      defaultSortOrder: "ascend" as const,
      sorter: (a: { fullName: string }, b: { fullName: string }) => {
        if (!a.fullName) return 1;
        if (!b.fullName) return -1;
        return a.fullName.localeCompare(b.fullName);
      },
    },
    {
      title: t("pages.users.user-table.email"),
      dataIndex: "email",
      key: "email",
    },
    {
      title: t("pages.users.user-table.role"),
      dataIndex: "role",
      key: "role",
      width: "7rem",
      render: (role: UserRole) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <UserTag role={role} />
        </div>
      ),
    },
    {
      title: t("action"),
      key: "action",
      width: "7rem",
      render: (user: { id: string }) => (
        <Button
          danger
          type="link"
          onClick={(event) => {
            event.stopPropagation();
            deleteUser(user.id);
          }}
        >
          {t("remove")}
        </Button>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={users}
      bordered
      title={() => <strong>{t("pages.users.user-table.title")}</strong>}
      style={{ width: "100%" }}
      rowKey={(record) => record.id}
    />
  );
};

export default UserTable;
